/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ProjectDurationResource } from './';
import {
    ProjectDurationResourceFromJSON,
    ProjectDurationResourceFromJSONTyped,
    ProjectDurationResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface BriefResourceBriefDetail
 */
export interface BriefResourceBriefDetail {
    /**
     * 
     * @type {string}
     * @memberof BriefResourceBriefDetail
     */
    currency?: string;
    /**
     * 
     * @type {string}
     * @memberof BriefResourceBriefDetail
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof BriefResourceBriefDetail
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof BriefResourceBriefDetail
     */
    projectType?: BriefResourceBriefDetailProjectTypeEnum;
    /**
     * 
     * @type {ProjectDurationResource}
     * @memberof BriefResourceBriefDetail
     */
    projectDuration?: ProjectDurationResource;
    /**
     * 
     * @type {string}
     * @memberof BriefResourceBriefDetail
     */
    startDateType?: BriefResourceBriefDetailStartDateTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof BriefResourceBriefDetail
     */
    startDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof BriefResourceBriefDetail
     */
    endDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof BriefResourceBriefDetail
     */
    workingStatus?: BriefResourceBriefDetailWorkingStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof BriefResourceBriefDetail
     */
    budget?: number;
    /**
     * 
     * @type {number}
     * @memberof BriefResourceBriefDetail
     */
    dailyFreelancerRate?: number;
    /**
     * 
     * @type {number}
     * @memberof BriefResourceBriefDetail
     */
    remoteFrequency?: number;
    /**
     * 
     * @type {string}
     * @memberof BriefResourceBriefDetail
     */
    freelancerAvailability?: BriefResourceBriefDetailFreelancerAvailabilityEnum;
    /**
     * 
     * @type {string}
     * @memberof BriefResourceBriefDetail
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof BriefResourceBriefDetail
     */
    country?: string;
}


/**
 * @export
 */
export const BriefResourceBriefDetailProjectTypeEnum = {
    FixedPrice: 'FIXED_PRICE',
    TimeAndMaterials: 'TIME_AND_MATERIALS'
} as const;
export type BriefResourceBriefDetailProjectTypeEnum = typeof BriefResourceBriefDetailProjectTypeEnum[keyof typeof BriefResourceBriefDetailProjectTypeEnum];

/**
 * @export
 */
export const BriefResourceBriefDetailStartDateTypeEnum = {
    AsSoonAsPossible: 'AS_SOON_AS_POSSIBLE',
    ChosenDate: 'CHOSEN_DATE',
    Unknown: 'UNKNOWN'
} as const;
export type BriefResourceBriefDetailStartDateTypeEnum = typeof BriefResourceBriefDetailStartDateTypeEnum[keyof typeof BriefResourceBriefDetailStartDateTypeEnum];

/**
 * @export
 */
export const BriefResourceBriefDetailWorkingStatusEnum = {
    Remotely: 'REMOTELY',
    Hybrid: 'HYBRID',
    OnSite: 'ON_SITE'
} as const;
export type BriefResourceBriefDetailWorkingStatusEnum = typeof BriefResourceBriefDetailWorkingStatusEnum[keyof typeof BriefResourceBriefDetailWorkingStatusEnum];

/**
 * @export
 */
export const BriefResourceBriefDetailFreelancerAvailabilityEnum = {
    OneDayPerWeek: 'ONE_DAY_PER_WEEK',
    TwoDaysPerWeek: 'TWO_DAYS_PER_WEEK',
    ThreeDaysPerWeek: 'THREE_DAYS_PER_WEEK',
    FourDaysPerWeek: 'FOUR_DAYS_PER_WEEK',
    FullTime: 'FULL_TIME'
} as const;
export type BriefResourceBriefDetailFreelancerAvailabilityEnum = typeof BriefResourceBriefDetailFreelancerAvailabilityEnum[keyof typeof BriefResourceBriefDetailFreelancerAvailabilityEnum];


/**
 * Check if a given object implements the BriefResourceBriefDetail interface.
 */
export function instanceOfBriefResourceBriefDetail(value: object): value is BriefResourceBriefDetail {
    return true;
}

export function BriefResourceBriefDetailFromJSON(json: any): BriefResourceBriefDetail {
    return BriefResourceBriefDetailFromJSONTyped(json, false);
}

export function BriefResourceBriefDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): BriefResourceBriefDetail {
    if (json == null) {
        return json;
    }
    return {
        
        'currency': json['currency'] == null ? undefined : json['currency'],
        'title': json['title'] == null ? undefined : json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'projectType': json['projectType'] == null ? undefined : json['projectType'],
        'projectDuration': json['projectDuration'] == null ? undefined : ProjectDurationResourceFromJSON(json['projectDuration']),
        'startDateType': json['startDateType'] == null ? undefined : json['startDateType'],
        'startDate': json['startDate'] == null ? undefined : (new Date(json['startDate'])),
        'endDate': json['endDate'] == null ? undefined : (new Date(json['endDate'])),
        'workingStatus': json['workingStatus'] == null ? undefined : json['workingStatus'],
        'budget': json['budget'] == null ? undefined : json['budget'],
        'dailyFreelancerRate': json['dailyFreelancerRate'] == null ? undefined : json['dailyFreelancerRate'],
        'remoteFrequency': json['remoteFrequency'] == null ? undefined : json['remoteFrequency'],
        'freelancerAvailability': json['freelancerAvailability'] == null ? undefined : json['freelancerAvailability'],
        'city': json['city'] == null ? undefined : json['city'],
        'country': json['country'] == null ? undefined : json['country'],
    };
}

export function BriefResourceBriefDetailToJSON(value?: BriefResourceBriefDetail | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'currency': value['currency'],
        'title': value['title'],
        'description': value['description'],
        'projectType': value['projectType'],
        'projectDuration': ProjectDurationResourceToJSON(value['projectDuration']),
        'startDateType': value['startDateType'],
        'startDate': value['startDate'] == null ? undefined : ((value['startDate']).toISOString().substring(0,10)),
        'endDate': value['endDate'] == null ? undefined : ((value['endDate']).toISOString().substring(0,10)),
        'workingStatus': value['workingStatus'],
        'budget': value['budget'],
        'dailyFreelancerRate': value['dailyFreelancerRate'],
        'remoteFrequency': value['remoteFrequency'],
        'freelancerAvailability': value['freelancerAvailability'],
        'city': value['city'],
        'country': value['country'],
    };
}

